import { useState, useEffect } from "react";

// Helper function to access nested fields dynamically
const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

const useRecommendations = (data, searchFields) => {
  const [recommendations, setRecommendations] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setRecommendations([]);
  }, [data]);

  const filterRecommendations = (value) => {
    if (value && data) {
      const fields = Array.isArray(searchFields)
        ? searchFields
        : [searchFields];
      const uniqueItems = Array.from(
        new Set(
          data.map((item) => {
            // Combine the fields' values into one string for comparison
            return fields
              .map((field) => getNestedValue(item, field)?.toString() || "") // Make sure to convert non-string fields
              .join(" ");
          })
        )
      );

      const filtered = uniqueItems.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );

      setRecommendations(filtered);
      setIsVisible(filtered.length > 0);
    } else {
      setRecommendations([]);
      setIsVisible(false);
    }
  };

  const handleKeyDown = (event, onRecommendationSelect, inputValue) => {
    if (recommendations.length > 0) {
      if (event.key === "ArrowDown") {
        setHighlightedIndex((prevIndex) =>
          prevIndex < recommendations.length - 1 ? prevIndex + 1 : 0
        );
      } else if (event.key === "ArrowUp") {
        setHighlightedIndex((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : recommendations.length - 1
        );
      } else if (event.key === "Enter") {
        if (highlightedIndex !== -1) {
          onRecommendationSelect(recommendations[highlightedIndex]);
        } else if (inputValue) {
          // If no recommendation is highlighted, perform search on input value
          onRecommendationSelect(inputValue);
        }
        setIsVisible(false); // Close the list after selection
      }
    }
  };

  return {
    recommendations,
    highlightedIndex,
    setHighlightedIndex,
    filterRecommendations,
    handleKeyDown,
    isVisible,
    setIsVisible,
  };
};

export default useRecommendations;
